"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validate = exports.ttsFields = exports.isSkipped = exports.initialValues = exports.icon = exports.getMetricsPrefix = exports.getMetrics = exports.getDataDefinitions = exports.getDataConnectorsValues = exports.getDataConnectors = exports.fields = exports.errorMessages = void 0;
var _react = _interopRequireDefault(require("react"));
var _isInt = _interopRequireDefault(require("validator/lib/isInt"));
var _cccisdSurveyCommon = require("cccisd-survey-common");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var fields = ['question', 'description', 'defaultValue', 'visualType', 'width', 'height', 'inputPrepend', 'inputAddon', 'isRequired', 'validationRule', 'minCharacters', 'maxCharacters', 'minNumber', 'maxNumber', 'regex',
// Error messages
'requiredErrorMessage', 'minCharactersErrorMessage', 'maxCharactersErrorMessage', 'numberErrorMessage', 'minNumberErrorMessage', 'maxNumberErrorMessage', 'emailErrorMessage', 'phoneErrorMessage', 'dateErrorMessage', 'regexErrorMessage', 'isTypeExpanded', 'isRequiredExpanded', 'isValidationExpanded'];
exports.fields = fields;
var ttsFields = function ttsFields(_ref) {
  var settings = _ref.settings,
    isMatrixMode = _ref.isMatrixMode;
  return isMatrixMode ? [] : ['question', 'description'];
};
exports.ttsFields = ttsFields;
var initialValues = {
  question: '<p><strong>What is your opinion about ...?</strong></p>',
  width: '600px',
  height: '60px',
  minCharacters: '100',
  visualType: 'textarea',
  validationRule: 'none',
  requiredErrorMessage: 'An answer is required.',
  minCharactersErrorMessage: 'Fewer than :min characters',
  maxCharactersErrorMessage: 'More than :max characters',
  numberErrorMessage: 'It should be a whole number',
  minNumberErrorMessage: 'It should be greater than or equal to :min',
  maxNumberErrorMessage: 'It should be less than or equal to :max',
  emailErrorMessage: 'It should be a valid email',
  phoneErrorMessage: 'It should be a valid phone',
  dateErrorMessage: 'It should be a date',
  regexErrorMessage: 'Incorrect value',
  isTypeExpanded: true,
  isRequiredExpanded: true,
  isValidationExpanded: true
};
exports.initialValues = initialValues;
var icon = /*#__PURE__*/_react["default"].createElement("i", {
  className: "glyphicon glyphicon-edit"
});
exports.icon = icon;
var errorMessages = {
  noMinAndMaxCharacters: 'You have to specify min or max',
  minCharactersIsNotNumber: 'Value should be a number between 1 and 10000',
  maxCharactersIsNotNumber: 'Value should be a number between 1 and 10000',
  minCharactersMoreThanMax: 'Max should be more than min',
  minNumberMoreThanMax: 'Max should be more than min',
  minNumberIsNotNumber: 'Value should be a whole number',
  maxNumberIsNotNumber: 'Value should be a whole number',
  regextIsRequired: 'Regex is required',
  regextIsWrong: 'Regex is wrong'
};
exports.errorMessages = errorMessages;
var validate = function validate(values) {
  var errors = {};
  if (values.validationRule === 'length') {
    if (!values.minCharacters && !values.maxCharacters) {
      errors.minCharacters = errorMessages.noMinAndMaxCharacters;
    }
    if (values.minCharacters && !(0, _isInt["default"])(values.minCharacters, {
      min: 1,
      max: 10000
    })) {
      errors.minCharacters = errorMessages.minCharactersIsNotNumber;
    }
    if (values.maxCharacters && !(0, _isInt["default"])(values.maxCharacters, {
      min: 1,
      max: 10000
    })) {
      errors.maxCharacters = errorMessages.maxCharactersIsNotNumber;
    }
    if (values.minCharacters && values.maxCharacters && !errors.minCharacters && !errors.maxCharacters) {
      if (+values.minCharacters > +values.maxCharacters) {
        errors.maxCharacters = errorMessages.minCharactersMoreThanMax;
      }
    }
  }
  if (values.validationRule === 'number') {
    if (values.minNumber && !(0, _isInt["default"])(values.minNumber)) {
      errors.minNumber = errorMessages.minNumberIsNotNumber;
    }
    if (values.maxNumber && !(0, _isInt["default"])(values.maxNumber)) {
      errors.maxNumber = errorMessages.maxNumberIsNotNumber;
    }
    if (values.minNumber && values.maxNumber && !errors.minNumber && !errors.maxNumber) {
      if (+values.minNumber > +values.maxNumber) {
        errors.maxNumber = errorMessages.minNumberMoreThanMax;
      }
    }
  }
  if (values.validationRule === 'regex') {
    if (!values.regex) {
      errors.regex = errorMessages.regextIsRequired;
    } else if (!/^\/.+\/[a-zA-Z]*$/.test(values.regex)) {
      errors.regex = errorMessages.regextIsWrong;
    }
  }
  return errors;
};
exports.validate = validate;
var getMetricsPrefix = function getMetricsPrefix() {
  return 'tx';
};
exports.getMetricsPrefix = getMetricsPrefix;
var getDataDefinitions = function getDataDefinitions(id, settings) {
  var metricsPrefix = getMetricsPrefix();
  var data = {
    title: (0, _cccisdSurveyCommon.stripTags)(settings.question),
    titleHtml: settings.question,
    type: 'text',
    questionType: 'openEnded',
    variableType: 'qualitative',
    tags: {
      system: ['answer']
    }
  };
  if (settings.validationRule === 'length') {
    if (settings.minCharacters) {
      data.minLength = +settings.minCharacters;
    }
    if (settings.maxCharacters) {
      data.maxLength = +settings.maxCharacters;
    }
  }
  if (settings.validationRule === 'number') {
    data.type = 'number';
    if (settings.minNumber) {
      data.minimum = +settings.minNumber;
    }
    if (settings.maxNumber) {
      data.maximum = +settings.maxNumber;
    }
  }
  return _defineProperty({}, id + '_answer', _objectSpread(_objectSpread({}, data), {}, {
    reportHeader: "".concat(metricsPrefix, "_").concat(id, "_answer")
  }));
};
exports.getDataDefinitions = getDataDefinitions;
var getMetrics = function getMetrics(id, settings, answer) {
  if (answer === undefined) {
    return _defineProperty({}, id + '_answer', null);
  }
  if (settings.validationRule === 'number') {
    return _defineProperty({}, id + '_answer', +answer);
  }
  return _defineProperty({}, id + '_answer', answer);
};
exports.getMetrics = getMetrics;
var getDataConnectors = function getDataConnectors(settings) {
  var connectors = {};
  if (settings.validationRule === 'number') {
    connectors.number = {
      type: 'number',
      title: 'Number'
    };
  } else {
    connectors.text = {
      type: 'string',
      title: 'Text'
    };
  }
  return connectors;
};
exports.getDataConnectors = getDataConnectors;
var getDataConnectorsValues = function getDataConnectorsValues(settings, answer) {
  return {
    text: function text() {
      return answer;
    },
    number: function number() {
      return +answer;
    }
  };
};
exports.getDataConnectorsValues = getDataConnectorsValues;
var isSkipped = function isSkipped(_ref6) {
  var settings = _ref6.settings,
    answer = _ref6.answer;
  return !answer;
};
exports.isSkipped = isSkipped;